import { IconButton, useToast } from "@design";
import { Copy, Download } from "lucide-react";
import { useTranslation } from "react-i18next";
import { saveBlob } from "@/lib/download";

/** Browsers only put PNG images on the clipboard. */
const canCopy = (blob: Blob) => blob.type === "image/png" && typeof ClipboardItem !== "undefined";

/** Download and Copy on an image in a reply: shown on hover or focus, always on touch screens. */
export function ImageActions({ blob, filename }: Readonly<{ blob: Blob; filename: string }>) {
  const { t } = useTranslation("chat", { keyPrefix: "markdown" });
  const toast = useToast();
  const copy = async () => {
    try {
      await navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
      toast.success(t("imageCopied"));
    } catch {
      toast.error(t("copyImageFailed"));
    }
  };
  return (
    <div className="absolute top-2 right-2 flex gap-1 opacity-0 transition-opacity group-focus-within:opacity-100 group-hover:opacity-100 [@media(hover:none)]:opacity-100">
      {canCopy(blob) && (
        <IconButton
          variant="secondaryBordered"
          size="sm"
          icon={<Copy />}
          aria-label={t("copyImage")}
          onClick={() => void copy()}
        />
      )}
      <IconButton
        variant="secondaryBordered"
        size="sm"
        icon={<Download />}
        aria-label={t("downloadImage")}
        onClick={() => saveBlob(blob, filename)}
      />
    </div>
  );
}
